var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.focusedNode)?_c('organization-chart',{attrs:{"datasource":_vm.focusedNode,"pan":_vm.internalConfig.pan,"zoom":_vm.internalConfig.zoom},on:{"node-click":_vm.onNodeClick}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }